module.exports = __webpack_public_path__ + "img/file-img-pdf.b0c5eca5.jpg";